<div class="flex-1 d-flex overflow-auto p-3">
    <key-leaflet-map #map
    [controls]="mapControls"
     class="flex-1 position-relative border"
        ></key-leaflet-map>
</div>